import Marquee from "react-fast-marquee";

const items = [
  "Luxury Gifting",
  "Corporate Hampers",
  "Wedding Favors",
  "Chocolate Bouquets",
  "Return Gifts",
  "Baby Showers",
  "Engagements",
  "Bobo Balloon Surprise",
];

export default function EditorialMarquee() {
  return (
    <section
      className="border-y border-[#311B4D] bg-[#140823] py-8"
      data-testid="editorial-marquee"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-serif text-3xl font-light italic text-[#EAD178]/80 md:text-5xl">
              {it}
            </span>
            <span className="text-2xl text-[#D4AF37]">&#10022;</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
